"use strict";
window.APP = window.APP || {};
APP.LabelConfirmationView = Backbone.View.extend({
    template: _.template($('#screen3Template').html()),
    
    events: {
        "click #confirmBottleButton": "confirmBottle"
    },
    
    initialize: function (options) {
        // access your data here
        this.brandid = options.brandid;
        if(this.brandid==0){
            this.brandid = 1;
        }
    },
    
    // populate the html to the dom
    render: function () {
        this.$el.html(
            this.template({brandid: this.brandid})
        );
        return this;
    },
    
    confirmBottle: function(e) {
        e.preventDefault();
        
        // Agregar efecto visual de confirmación
        const button = this.$("#confirmBottleButton");
        button.addClass("confirmed");
        button.find(".bottle-confirm-button__text").text("¡Confirmado!");
        
        // Opcional: guardar la confirmación en localStorage
        localStorage.setItem("bottleConfirmed", "true");
        localStorage.setItem("confirmedBrand", this.brandid);
        
        // Opcional: avanzar automáticamente después de un delay
        setTimeout(() => {
            window.location.hash = "labelcustomization";
        }, 1500);
    }
});